import { defineMessages } from 'react-intl';

export default defineMessages({
  mcpPageTitle: {
    id: 'mcpPageTitle',
    defaultMessage: 'My custom products & projects'
  }
});
